export default "__VITE_PUBLIC_ASSET__47c4c5a1__"